import React from 'react';

const Comissions: React.StatelessComponent = props => (
  <div>
    <h1>Comissions route works</h1>
  </div>
);

export default Comissions;
